import { render, staticRenderFns } from "./PaymentRequisitionBulkUpdateOwnerDialog.vue?vue&type=template&id=3de835e8&"
import script from "./PaymentRequisitionBulkUpdateOwnerDialog.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionBulkUpdateOwnerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports